/* ==========================================================================
   NASHIRA STANDALONE PRODUCT CARD - runtime
   Zero dependencies. Namespaced under window.NSCard.
   ========================================================================== */
(function () {
  'use strict';

  var WISH_KEY = 'ns_card_wishlist';
  var ROTATE_MS = 3000;
  var SWIPE_MIN = 40;

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------ toast --------------------------------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('ns-card-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ns-card-toast';
      el.className = 'ns-card-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    // force reflow so the transition always runs
    void el.offsetWidth;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }

  /* ---------------------------- wishlist -------------------------------- */
  function readWish() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function paintWish(handle, on) {
    $$('[data-ns-wish="' + cssEscape(handle) + '"]').forEach(function (btn) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function cssEscape(v) {
    return String(v).replace(/["\\]/g, '\\$&');
  }

  function syncAllWish() {
    var list = readWish();
    $$('[data-ns-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-ns-wish')) > -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------------------------- quick add ------------------------------- */
  function notifyHostCart(cart, variantId) {
    document.dispatchEvent(new CustomEvent('ns:cart:added', {
      detail: { variantId: variantId, cart: cart },
      bubbles: true
    }));
    // Nudge common host-theme refresh hooks without touching their DOM.
    // Impact (Maestrooo) listens for these to re-render its drawer.
    document.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { cart: cart, baseEvent: 'variant:add' }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (window.Shopify && window.Shopify.onCartUpdate) {
      try { window.Shopify.onCartUpdate(cart); } catch (e) {}
    }
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-ns-qadd');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          toast(res.description || 'Could not add to bag');
          return;
        }
        toast('Added to your bag');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { notifyHostCart(cart, id); });
      })
      .catch(function () { toast('Something went wrong'); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  /* -------------------- delegated document listeners --------------------- */
  var delegated = false;
  function bindDelegates() {
    if (delegated) return;
    delegated = true;

    document.addEventListener('click', function (e) {
      var wish = e.target.closest ? e.target.closest('[data-ns-wish]') : null;
      if (wish) {
        e.preventDefault();
        e.stopPropagation();
        var handle = wish.getAttribute('data-ns-wish');
        var list = readWish();
        var i = list.indexOf(handle);
        var on;
        if (i > -1) { list.splice(i, 1); on = false; }
        else { list.push(handle); on = true; }
        writeWish(list);
        paintWish(handle, on);
        toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
        return;
      }

      var qadd = e.target.closest ? e.target.closest('[data-ns-qadd]') : null;
      if (qadd) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(qadd);
      }
    });
  }

  /* ---------------------------- per-card init ---------------------------- */
  function initCard(card) {
    if (card.__nsInit) return;
    card.__nsInit = true;

    var media = $('[data-ns-media]', card);
    var slides = $$('[data-ns-slide]', card);
    var dots = $$('[data-ns-dot]', card);
    var idx = 0;
    var timer = null;
    var inView = false;
    var hovering = false;

    function show(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    function start() {
      if (timer || reduceMotion || slides.length < 2) return;
      timer = setInterval(function () { show(idx + 1); }, ROTATE_MS);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function evaluate() {
      if (inView || hovering) { start(); } else { stop(); }
    }

    if (slides.length > 1) {
      var prev = $('[data-ns-prev]', card);
      var next = $('[data-ns-next]', card);
      if (prev) prev.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); show(idx - 1);
      });
      if (next) next.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); show(idx + 1);
      });

      if (media) {
        media.addEventListener('mouseenter', function () { hovering = true; evaluate(); });
        media.addEventListener('mouseleave', function () { hovering = false; evaluate(); });

        var sx = 0;
        media.addEventListener('touchstart', function (e) {
          sx = e.changedTouches[0].clientX;
        }, { passive: true });
        media.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > SWIPE_MIN) { show(dx < 0 ? idx + 1 : idx - 1); }
        }, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            evaluate();
          });
        }, { threshold: 0.4 });
        io.observe(card);
        card.__nsIO = io;
      } else {
        inView = true;
        evaluate();
      }
    }

    /* ------------------------------ swatches ---------------------------- */
    var variants = [];
    var dataEl = $('[data-ns-card-variants]', card);
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    $$('[data-ns-swatch]', card).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var vid = btn.getAttribute('data-ns-variant');
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(vid)) { match = variants[i]; break; }
        }

        $$('[data-ns-swatch]', card).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        if (match && match.img && slides[0]) {
          var img = slides[0].querySelector('img');
          if (img) {
            img.setAttribute('srcset', '');
            img.src = match.img;
          }
          show(0);
        }
      });
    });
  }

  /* -------------------------------- init --------------------------------- */
  function init(root) {
    bindDelegates();
    var scope = root && root.querySelectorAll ? root : document;
    $$('[data-ns-card]', scope).forEach(initCard);
    if (scope !== document && scope.matches && scope.matches('[data-ns-card]')) {
      initCard(scope);
    }
    syncAllWish();
  }

  window.NSCard = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
